// SPDX-License-Identifier: Apache-2.0

import { ReactElement } from "react";

// If set to true, no notices are shown and the onSubmit function will be
// directly called.
let noticesDeactivated = false;
export const deactivateNotices = () => {
  noticesDeactivated = true;
};

export interface InfoNotice {
  title: string;
  content: ReactElement;
}

export const dispatchPerunNotice = (notice: InfoNotice) => {
  if (noticesDeactivated) {
    return;
  }
  document.dispatchEvent(
    new CustomEvent<InfoNotice>("InfoNotice", {
      bubbles: true,
      detail: notice,
      cancelable: true,
    }),
  );
};

export const revertPerunNotice = () => {
  document.dispatchEvent(new CustomEvent<ReactElement>("CloseInfoNotice"));
};

export const infoNotice = (title: string, info: string): InfoNotice => {
  const content = (
    <>
      <p>{info}</p>
    </>
  );
  return {
    title: title,
    content: content,
  };
};
